import React, { useState, memo } from 'react'
import { Trans } from '@lingui/react'
import { Tabs, TabPanel, TabLink, Section } from '../../ui-kit'
import { SignIn } from './SignIn'
/* import { SignUp } from './SignUp' */

type Props = {
  activeTabIndex: number
  onChange: (activeTabIndex: number, oldActiveTab?: any, e?: any) => void
}

export const TabsAuth = memo((props: Props) => {
  const { activeTabIndex, onChange } = props

  return (
    <>
      <Tabs
        activeTabIndex={activeTabIndex}
        onChange={(activeTab, _oldActiveTab, _e) => {
          onChange(activeTab)
        }}
        classesNav="tab-list--centered text-nowrap">
        <TabPanel
          tab={
            <TabLink size="medium" id="tab-signin" href="#tab1">
              <Trans>Prihlásenie</Trans>
            </TabLink>
          }>
          {activeTabIndex === 0 && (
            <Section className="pb-none">
              <SignIn />
            </Section>
          )}
        </TabPanel>
        {/* <TabPanel
          tab={
            <TabLink size="medium" id="tab-signup" href="#tab2">
              <Trans>Registrácia</Trans>
            </TabLink>
          }>
          {activeTabIndex === 1 && (
            <Section className="pb-none">
              <SignUp />
            </Section>
          )}
        </TabPanel> */}
      </Tabs>
    </>
  )
})

// eslint-disable-next-line react/no-multi-comp
export const TabsAuthStatefull: React.FC<{ defaultActiveTabIndex?: number }> = memo(
  ({ defaultActiveTabIndex = 0 }) => {
    const [activeTabIndex, setActiveTabIndex] = useState(defaultActiveTabIndex)
    return (
      <TabsAuth
        activeTabIndex={activeTabIndex}
        onChange={activeTab => {
          setActiveTabIndex(activeTab)
        }}
      />
    )
  }
)
